import React, { useEffect, useMemo, useState } from "react";
import "../../styles/Super.css";
import AdminHeader from "./Header";
import { api } from "../../include/api";
import { getAdmin } from "../../include/function";

const toISODate = (d) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const AdminLogs = () => {
  const today = useMemo(() => toISODate(new Date()), []);
  const admin = useMemo(() => getAdmin(), []);

  const canViewLogs = useMemo(() => {
    if (admin?.createdBy === "super") return true;
    const perms = admin?.roleProperties || [];
    const p = perms.find((x) => x.pageUrl === "/admin/logs");
    return !!p && (p.view === "true" || p.view === 1);
  }, [admin]);

  const [date, setDate] = useState(today);
  const [user, setUser] = useState("");
  const [action, setAction] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [logs, setLogs] = useState([]);

  const fetchLogs = async () => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams();
      if (date) params.set("date", date);
      if (user.trim()) params.set("user", user.trim());
      if (action.trim()) params.set("action", action.trim());

      // Don't send Authorization header here (avoids CORS preflight).
      // Also hit index.php directly to avoid any redirect on `/logger/`.
      const res = await api.get(`/logger/index.php?${params.toString()}`);
      const payload = res?.data || {};

      if (payload.status === false) {
        setLogs([]);
        setError(payload.message || "Unable to fetch logs");
        return;
      }

      setLogs(Array.isArray(payload.logs) ? payload.logs : []);
    } catch (e) {
      setLogs([]);
      setError(e?.message || "Unable to fetch logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (canViewLogs) fetchLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canViewLogs]);

  return (
    <AdminHeader title="Logs">
      <div className="container-fluid p-3">
        {!canViewLogs ? (
          <div className="alert alert-danger mb-0">Access denied</div>
        ) : (
        <div
          className="card"
          style={{
            borderRadius: "12px",
            border: "1px solid #e6e6e6",
            overflow: "hidden",
          }}
        >
          <div className="card-header bg-white d-flex align-items-center justify-content-between">
            <h5 className="mb-0">Logs</h5>
          </div>

          <div className="card-body">
            <div className="row g-3 align-items-end">
              <div className="col-12 col-md-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              <div className="col-12 col-md-3">
                <label className="form-label">User</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="customerId / email / adminId"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                />
              </div>

              {/* <div className="col-12 col-md-3">
                <label className="form-label">Action</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="customer.login.success"
                  value={action}
                  onChange={(e) => setAction(e.target.value)}
                />
              </div> */}

              <div className="col-12 col-md-3 d-flex gap-2">
                <button
                  className="btn btn-primary w-100"
                  onClick={fetchLogs}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Search"}
                </button>
              </div>
            </div>

            {error ? (
              <div className="alert alert-danger mt-3 mb-0">{error}</div>
            ) : null}

            <div className="table-responsive mt-3">
              <table className="table table-bordered table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="text-nowrap" style={{ width: "180px" }}>
                      Timestamp
                    </th>
                    <th className="text-nowrap" style={{ width: "220px" }}>
                      User
                    </th>
                    <th className="text-nowrap" style={{ width: "260px" }}>
                      Action
                    </th>
                    <th>Context</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading && logs.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No logs found
                      </td>
                    </tr>
                  ) : null}
                      {logs.map((l, idx) => {
                        let actionArray = l.action.split(".")
                    return(
                    <tr key={`${l.timestamp}-${l.user}-${l.action}-${idx}`}>

                      <td className="text-nowrap">{l.timestamp || "-"}</td>
                      <td className="text-nowrap">{l.user || "-"}</td>
                        <td className="text-nowrap"><span className={actionArray[2] === "success"?"badge text-bg-success" :"badge text-bg-danger"}>{actionArray[0]}</span> {actionArray[1] }</td>
                      <td style={{ fontFamily: "monospace", fontSize: "12px" }}>
                        {l.context ? JSON.stringify(l.context) : "-"}
                      </td>
                          </tr>
                    )
})}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        )}
      </div>
    </AdminHeader>
  );
};

export default AdminLogs;

